/* ==========================================================================
   UiPanelAccommodationPackages > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const UiPanelClient = require('@bluekiri/alexandria-contrib-components/components/ui-panel/client/js');
const PanelAccommodationClient = require('../../../panel-accommodation-packages/client/js');
const baseConfig = require('./config');

/**
 * UiPanelAccommodationPackages component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function UiPanelAccommodationPackages(selector = '[data-component="UiPanel"]', configuration = {}) {
    if (elementExist(selector)) {
        // Instance reference
        const instance = {};

        instance.element = document.querySelector(selector);

        // Config
        const config = { ...baseConfig(), ...configuration };
        instance.config = config;

        // panel accommodation reference
        const actionAddRoom = instance.element.querySelector(config.actionAddRoom.selector);
        const triggerInput = config.panel && config.panel.triggerInput ? config.panel.triggerInput : false;

        instance.accommodation = PanelAccommodationClient(`${selector} [data-component="PanelAccommodationPackages"]`, {
            triggerAddRoom: [actionAddRoom],
            triggerInput: triggerInput || false
        });

        // UIPanel reference

        instance.type = config.type || config.uiPanel.type;
        instance.panel = UiPanelClient(selector, {
            ...config.panel,
            type:
                instance.config.panel && instance.config.panel.triggerInput ? instance.config.panel.triggerInput.id : 0
        });

        return instance;
    }
};
